export const iconsContainerCss = {
  position: "relative",
  zIndex: 1,
  display: "flex",
  alignItems: "center",
  "> *": {
    marginLeft: "8px",
  },
};
